module.exports = __webpack_public_path__ + "img/abinoid-face-cleanser.d9f521ae.jpg";